function Sidebar(){
    return (
        <div class='sidebar'>Sidebar</div>
    );
}

export default Sidebar;